// covered-by: frontends/carrie/src/ask-v2/project/__tests__/openItemsApi.test.ts
import {
  type ListAskPunttProjectOpenItemsResponse,
  type ResolveAskPunttOpenItemResponse,
} from "@mg/schemas/src/christo/askPunttOpenItems";

import { API_URL } from "../../config/env";
import { smartFetch } from "../../utils/http";

const BASE = `${API_URL}/private/catalyst/ask-puntt/projects`;

/** why: open item ids may contain ':' — encode path segments so gateways match the route. */
function openItemPathSegment(itemId: string): string {
  return encodeURIComponent(itemId);
}

export async function listProjectOpenItems(
  projectId: string,
): Promise<ListAskPunttProjectOpenItemsResponse> {
  const json = await smartFetch(`${BASE}/${projectId}/open-items`, {
    method: "GET",
  });
  return json as ListAskPunttProjectOpenItemsResponse;
}

export async function listOpenItemAssignees(projectId: string) {
  const json = await smartFetch(`${BASE}/${projectId}/open-items/assignees`, {
    method: "GET",
  });
  return json as { assignees: { userId: string; name: string }[] };
}

export async function assignOpenItem(
  projectId: string,
  itemId: string,
  ownerUserId: string,
): Promise<void> {
  await smartFetch(
    `${BASE}/${projectId}/open-items/${openItemPathSegment(itemId)}/assign`,
    {
      method: "POST",
      body: JSON.stringify({ ownerUserId }),
    },
  );
}

export async function nudgeOpenItem(
  projectId: string,
  itemId: string,
): Promise<void> {
  await smartFetch(
    `${BASE}/${projectId}/open-items/${openItemPathSegment(itemId)}/nudge`,
    {
      method: "POST",
    },
  );
}

/** A conflict card's click: the typed choice and why; what warhol's decision door did (L2.20). */
export async function resolveOpenItem(
  projectId: string,
  itemId: string,
  resolution: "keep" | "accept",
  reason: string,
): Promise<ResolveAskPunttOpenItemResponse> {
  const json = await smartFetch(
    `${BASE}/${projectId}/open-items/${openItemPathSegment(itemId)}/resolve`,
    {
      method: "POST",
      body: JSON.stringify({ resolution, reason }),
    },
  );
  return json as ResolveAskPunttOpenItemResponse;
}
